module.exports = __webpack_public_path__ + "static/img/63.ff3a417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/63.jpg
// module id = xqyx
// module chunks = 0